/** The nine readiness areas of the ReImagine Lite form. Keys, order and question text match the original form. */
export interface LiteArea {
  key: string;
  title: string;
  /** Icon name understood by landing/icons.tsx */
  icon: string;
  question: string;
}

export const AREAS: LiteArea[] = [
  {
    key: "project-type",
    title: "Business Strategy & Vision Alignment",
    icon: "target",
    question:
      "Do you have an data+AI strategy aligned with business goals and supported by a clear vision?",
  },
  {
    key: "maturity",
    title: "Business Readiness",
    icon: "briefcase",
    question: "Is the business committed to AI initiative and what it will take on their part?",
  },
  {
    key: "sector",
    title: "AI Readiness & Adoption Strategy",
    icon: "sparkle",
    question: "Have you identified key AI use cases, and is there a plan for adoption across teams?",
  },
  {
    key: "function",
    title: "Technology Readiness",
    icon: "chip",
    question: "Is your technology ecosystem ready to support AI initiatives?",
  },
  {
    key: "capability",
    title: "Data Readiness",
    icon: "database",
    question: "Do you have the trustworthy data (internal, external, or third-party) to support AI use cases?",
  },
  {
    key: "impact",
    title: "Risk Management & Governance",
    icon: "shield",
    question: "Do you have governance frameworks in place to ensure ethical and secure AI deployment?",
  },
  {
    key: "dummy1",
    title: "Talent Readiness",
    icon: "team",
    question:
      "Are your teams equipped with the right domain expertise and technical skills to effectively adopt and leverage AI tools?",
  },
  {
    key: "dummy2",
    title: "Impact, Value & Performance Measurement",
    icon: "trend",
    question: "Do you have metrics to track the impact, ROI, and performance of your AI initiatives?",
  },
  {
    key: "dummy3",
    title: "Cost Effectiveness",
    icon: "coin",
    question: "Is the required funding available to initiate and scale AI transformation?",
  },
];

export const ANSWERS = ["Yes", "No", "Maybe"] as const;
